function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTigoLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.74,
    height: 46,
    viewBox: "0 0 64.74 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.51,9.14a2.91,2.91,0,0,1-2.8-3,2.83,2.83,0,0,1,5.64-.39v.39A2.94,2.94,0,0,1,17.51,9.14Zm26,31.42a16,16,0,0,0,13.7-6.91h.16v2.56a8.34,8.34,0,0,1-1,3.42C54.8,42.44,49.75,46,44.18,46A15.49,15.49,0,0,1,31.6,39.85a7.94,7.94,0,0,1-1.14-3.76v-2.5h.15C33.45,37.4,37.54,40.56,43.53,40.56ZM55.75,3.86a10.69,10.69,0,0,0-8.87,4.05h-.1V5.84a4.81,4.81,0,0,1,.63-2A10.19,10.19,0,0,1,55.31,0a10.36,10.36,0,0,1,8.15,3.67,4.3,4.3,0,0,1,.76,2.24V8h-.1a10.46,10.46,0,0,0-8.41-4.14ZM4.83,5.9v4.41h6.92v2a2.62,2.62,0,0,1-2.9,2.31h-4v7.62C4.82,24.79,6,25.76,8,25.76a7.61,7.61,0,0,0,3.61-.68h.17v1.71c0,2-1.48,3.27-4.38,3.27-5,0-7.48-2.71-7.48-7.24V11.1A4.74,4.74,0,0,1,1.34,7.24,3.5,3.5,0,0,1,3.66,5.88H4.83ZM20.26,23.76c0,2,.85,2.58,3,2.58h.92v1.05c0,2.13-.84,3-2.94,3-3.84,0-5.95-2.15-5.95-6.14V10.9h1.36a3.23,3.23,0,0,1,3.56,2.85,3.13,3.13,0,0,1,0,.81v9.2Zm23.2,1.93c0,3.52-2.4,5.23-7.31,5.23-5.35,0-10.77-3.51-10.77-10.22C25.38,14.4,30.23,10,37.16,10c4.08,0,6,2.19,6,4.22v1.71h-.67l-.09-.08a9.61,9.61,0,0,0-5.7-1.57,5.88,5.88,0,0,0-6.26,5.47c0,.14,0,.28,0,.42,0,5.41,3.4,6.49,6.24,6.49,2,0,2.13-.7,2.13-1.47V23.64a15.34,15.34,0,0,0-.29-2.78l-.11-.46H41a2.49,2.49,0,0,1,2.49,2.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.35,26C52,26,50.6,23.74,50.6,19.9c0-3.19,1.44-5.48,4.31-5.48,3.27,0,4.75,2.29,4.75,6.16,0,3.16-1.36,5.41-4.31,5.41Zm0-15.91c-6.47,0-9.9,4.66-9.9,10.47,0,5.11,3.43,9.75,9.5,9.75,6.45,0,9.92-4.64,9.92-10.44C64.83,14.78,61.35,10.12,55.35,10.12Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTigoLogoWhite);
export default __webpack_public_path__ + "static/media/tigo-logo-white.4f21b70aa30853408bef68b33d58f42b.svg";
export { ForwardRef as ReactComponent };